import type { Constants } from '@salesforce/scv-connector-base';
import { CallResult } from '@salesforce/scv-connector-base';
import { PhoneCallGenerator } from '@main/generators/phone-call.generator';

export class CallResultGenerator {
  static generate(
    callId: string,
    callType: Constants.CALL_TYPE,
    phoneNumber: string,
  ): CallResult {
    return new CallResult({
      call: PhoneCallGenerator.generate(callId, callType, phoneNumber),
    });
  }
}
